/*eslint complexity: ["error", 38]*/
import React from 'react';
import { Form } from 'react-bootstrap';

import FormRow from '../../../app/components/FormRow';
import { FormSelect } from '../../../app/components/FormSelect';
import {
  CreateUpdateExaminedDto,
  CreateUpdateExternalReferralDto,
} from '../../../common/spdCore/autogenerated/spdApiClient';
import { Gender } from '../../../common/spdCore/validation/schemas';
import { CreatableClearableSelector } from '../Selects/CreatableClearableSelector';
import DictionarySelector from '../Selects/DictionarySelector';
import { IDCardTypeSelector } from '../Selects/IDCardTypeSelector';
import momencik from '../../../common/momencik';
import { useSpdCore } from '../../../common/hooks/useSpdCore';

interface ExaminedPersonalDataFormProps {
  externalReferral: CreateUpdateExternalReferralDto;
  textOrEmpty: (text: string | null | undefined) => string;
  propertyChangeExamined: (obj: Partial<CreateUpdateExaminedDto>) => void;
  kindOfExam: string;
  withoutPesel: boolean;
}

const ExaminedPersonalDataForm: React.FC<ExaminedPersonalDataFormProps> = ({
  externalReferral,
  textOrEmpty,
  propertyChangeExamined,
  withoutPesel,
}) => {
  const spdCore = useSpdCore();

  return (
    <>
      <FormRow controlId="examined" label="Imię">
        <Form.Control
          type="text"
          value={externalReferral?.examined?.firstname || ''}
          onChange={e => propertyChangeExamined({ firstname: e.target.value })}
        />
      </FormRow>
      <FormRow controlId="examined" label="Nazwisko">
        <Form.Control
          type="text"
          value={externalReferral?.examined?.surname || ''}
          onChange={e => propertyChangeExamined({ surname: e.target.value })}
        />
      </FormRow>
      {!withoutPesel && (
        <FormRow controlId="examined" label="PESEL">
          <Form.Control
            type="text"
            value={externalReferral?.examined?.pesel || ''}
            onChange={e => propertyChangeExamined({ pesel: e.target.value })}
          />
        </FormRow>
      )}
      <FormRow controlId="sex" label="Płeć">
        <FormSelect
          value={externalReferral?.examined?.sex}
          options={[
            { value: Gender.Female, label: 'Kobieta' },
            { value: Gender.Male, label: 'Mężczyzna' },
          ]}
          onChange={value => propertyChangeExamined({ sex: value })}
        />
      </FormRow>
      <FormRow controlId="date" label="Data urodzenia">
        <Form.Control
          type="date"
          name="datepic"
          placeholder="DateRange"
          value={momencik(
            externalReferral?.examined?.dateOfBirth,
            'YYYY-MM-DD',
          )}
          onChange={e =>
            propertyChangeExamined({
              dateOfBirth: new Date(e.target.value),
            })
          }
        />
      </FormRow>
      {!withoutPesel && (
        <>
          <FormRow controlId="iDCardType" label="Nazwa dokumentu">
            <IDCardTypeSelector
              idCardTypeDictId={externalReferral?.examined?.idCardTypeDictId}
              iDCardType={externalReferral?.examined?.iDCardType}
              onChange={(v, clearLegacy) => {
                if (clearLegacy) {
                  propertyChangeExamined({
                    idCardTypeDictId: undefined,
                    iDCardType: undefined,
                  });
                } else {
                  propertyChangeExamined({ idCardTypeDictId: v ?? undefined });
                }
              }}
            />
          </FormRow>
          <FormRow controlId="iDCardNumber" label="Nr dokumentu">
            <Form.Control
              type="text"
              value={externalReferral?.examined?.iDCardNumber || ''}
              onChange={e =>
                propertyChangeExamined({ iDCardNumber: e.target.value })
              }
            />
          </FormRow>
          <FormRow controlId="country" label="Kraj wydania dokumentu">
            <DictionarySelector
              value={externalReferral?.examined?.countryId || ''}
              onChange={e =>
                propertyChangeExamined({
                  countryId: e?.value,
                })
              }
              dictionary="Kod kraju"
              clearable={true}
              searchByShortname={true}
            />
          </FormRow>
        </>
      )}
      <FormRow controlId="email" label="E-mail">
        <Form.Control
          type="email"
          value={textOrEmpty(externalReferral?.examined?.email)}
          onChange={e => propertyChangeExamined({ email: e.target.value })}
        />
      </FormRow>
      <FormRow controlId="phone" label="Telefon">
        <Form.Control
          type="text"
          value={textOrEmpty(externalReferral?.examined?.phone)}
          onChange={e => propertyChangeExamined({ phone: e.target.value })}
        />
      </FormRow>

      {/* Address Fields */}
      <FormRow controlId="postcode" label="Kod pocztowy">
        <Form.Control
          type="text"
          value={textOrEmpty(externalReferral?.examined?.postcode)}
          onChange={e => propertyChangeExamined({ postcode: e.target.value })}
        />
      </FormRow>
      <FormRow controlId="city" label="Miejscowość">
        <CreatableClearableSelector
          value={textOrEmpty(externalReferral?.examined?.city)}
          onChange={chosen => propertyChangeExamined({ city: chosen.label })}
          provider={spdCore.examineds.getCitiesByName}
        />
      </FormRow>
      <FormRow controlId="street" label="Ulica">
        <CreatableClearableSelector
          value={textOrEmpty(externalReferral?.examined?.street)}
          onChange={chosen => propertyChangeExamined({ street: chosen.label })}
          provider={spdCore.examineds.getStreetsByName}
        />
      </FormRow>
      <FormRow controlId="numbers" label=" Numer">
        <Form.Control
          type="text"
          value={textOrEmpty(externalReferral?.examined?.numbers)}
          onChange={e => propertyChangeExamined({ numbers: e.target.value })}
        />
      </FormRow>
    </>
  );
};

export default ExaminedPersonalDataForm;
